import { SectionMessage, Space } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceEditorBaseCurrency } from '../../../../../../../../hooks/useInvoiceEditorBaseCurrency'

interface DepositInvoiceCurrencyChangeBannerProps {
  onClose: () => void
}

export const DepositInvoiceCurrencyChangeBanner = ({
  onClose,
}: DepositInvoiceCurrencyChangeBannerProps): ReactElement | null => {
  const { t } = useTranslation()
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { baseCurrency, isLoading } = useInvoiceEditorBaseCurrency()

  const currency = invoiceEditorForm.watch('currency')
  const isCurrencyDifferent = currency !== baseCurrency

  const handleCloseButtonClick = useCallback(() => onClose(), [onClose])

  if (!isCurrencyDifferent || isLoading) {
    return null
  }

  return (
    <>
      <SectionMessage closable icon="info" onClose={handleCloseButtonClick} showIcon variant="warning">
        {t('external_invoices.editor.form.deposit_invoice_currency_change_banner.message')}
      </SectionMessage>
      <Space size="s16" />
    </>
  )
}
